import React from 'react';
import { Route, Redirect, useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { userState } from '../state';
import { routes, join } from './DomainRoutes';

// A wrapper for <Route> that redirects to the login screen if you're not yet authenticated.
export default function PrivateRoute({ children, ...rest }) {
	const { url } = useParams();
	const { isLogged } = useRecoilValue(userState);
	return (
		<Route
			{...rest}
			render={({ location }) =>
				isLogged ? (
					children
				) : (
					<Redirect
						to={{
							pathname: join(url, routes.find((route) => route.isHome).path),
							state: { from: location },
						}}
					/>
				)
			}
		/>
	);
}
